module.exports = __webpack_public_path__ + "static/media/thumbnail-hatvan-uzemi-epulet.0d8de0d1.jpg";